import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { User, Roles, status } from '../../core/user';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../core/auth.service';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { Investor } from '../shared/models/investor';
import * as firebase from 'firebase';

@Injectable()
export class ManageUserService {
  userList: AngularFirestoreCollection<User>;
  userData: User;
  investorsList: AngularFirestoreCollection<Investor>;
  newInvestorsList: AngularFirestoreCollection<Investor>;
  filterList: AngularFirestoreCollection<Investor>;
  // investorByEditor: AngularFirestoreCollection<InvestorData>;
  pageInvestor: AngularFirestoreCollection<Investor>;
  currentUser: User;
  constructor(
    private afs: AngularFirestore,
    private router: Router,
    private afAuth: AngularFireAuth,
    private authService: AuthService
  ) {}

  getData() {
    this.userList = this.afs.collection('users');
    return this.userList;
  }

  filterData(filter: Object) {
    this.userList = this.afs.collection('users', ref => {
      let query:
        | firebase.firestore.CollectionReference
        | firebase.firestore.Query = ref;
      if (filter['email'] && filter['email'].length > 0) {
        query = query.where('email', '==', filter['email']);
      } else {
        if (filter['radio'] && filter['radio'] == 'superAdmin') {
          query = query.where('roles.superAdmin', '==', true);
        } else if (filter['radio'] && filter['radio'] == 'admin') {
          query = query.where('roles.admin', '==', true);
        } else if (filter['radio'] && filter['radio'] == 'editor') {
          query = query.where('roles.editor', '==', true);
        }
      }
      return query;
    });
    return this.userList;
  }

  getDataByKey(key: string) {
    return this.afs.doc<User>(`users/${key}`).valueChanges();
    // x.subscribe(
    //   value => {
    //     this.userData = value;
    //   }
    // );
    // return this.userData;
  }

  update(updatedData: User) {
    this.afs
      .doc<User>(`users/${updatedData.uid}`)
      .set(updatedData, {
        merge: true
      })
      .then(value => this.router.navigate(['/manage-user']))
      .catch(error => console.log(error));
  }
  createUser(newUserFormValue, errorCallback?): any {
    this.afAuth.auth
      .createUserWithEmailAndPassword(
        newUserFormValue.email,
        newUserFormValue.userPassword
      )
      .then(value => {
        this.addUserData(newUserFormValue, value.uid)
          .then(value1 => {
            this.authService.signOut();
          })
          .catch(error => {
            console.log(error);
          });
      }).catch(error=>{
        console.log(error);
        if(errorCallback){
          errorCallback(error);
        }
      });
  }

  // getInvestors() {
  //   this.investorsList = this.afs.collection('InvestorData');
  //   return this.investorsList;
  // }

  // getInvestorByEditor(eid: string) {
  //   this.investorByEditor = this.afs.collection('InvestorData', ref => {
  //     return ref.where('creatorId', '==', eid);
  //   });
  //   return this.investorByEditor;
  // }

  getNewStatusInvestors() {
    this.newInvestorsList = this.afs.collection('InvestorData', ref => {
      return ref.where('status', '==', status.new);
    });
    return this.newInvestorsList;
  }
  getFirstInvestor(
    eid: string,
    page: number,
    newStatus?: boolean,
    email?: string,
    mobileNo?: string,
    name?: string,
  ) {
    name = name.toLowerCase();
    this.pageInvestor = this.afs.collection('InvestorData', ref => {
      let query:
        | firebase.firestore.CollectionReference
        | firebase.firestore.Query = ref;
      if(!(name && name.length > 0)){
        if (email && email.length > 0) {
          query = query.where('email', '==', email);
        } else if (mobileNo && mobileNo.length > 0) {
          query = query.where('phone', '==', mobileNo);
        } else if (newStatus) {
          query = query.where('status', '==', status.new);
        }
        if (eid) {
          query = query.where('creatorId', '==', eid);
        }
        return query.orderBy('updatedAt').limit(page);
      } else {
        query = query.orderBy('searchName');
        query = query.startAt(name);
        query = query.endAt(name+"\uf8ff")
        return query;
      }
        
    });
    return this.pageInvestor;

    // if (eid && eid.length > 0) {

    // } else {
    //   this.pageInvestor = this.afs.collection('InvestorData', ref => {
    //     return ref.orderBy('updatedAt').limit(page);
    //   });
    //   return this.pageInvestor;
    // }
  }
  getNextInvestor(
    eid: string,
    page: number,
    lastElement: Investor,
    newStatus?: boolean,
    email?: string,
    mobileNo?: string
  ) {
    this.pageInvestor = this.afs.collection('InvestorData', ref => {
      let query:
        | firebase.firestore.CollectionReference
        | firebase.firestore.Query = ref;
      if (email && email.length > 0) {
        query = query.where('email', '==', email);
      } else if (mobileNo && mobileNo.length > 0) {
        query = query.where('phone', '==', mobileNo);
      } else if (newStatus) {
        query = query.where('status', '==', status.new);
      }
      if (eid) {
        query = query.where('creatorId', '==', eid);
      }
      return query
        .orderBy('updatedAt')
        .startAfter(lastElement.updatedAt)
        .limit(page);
    });
    return this.pageInvestor;
  }
  getPreviousInvestor(
    eid: string,
    page: number,
    firstElement: Investor,
    newStatus?: boolean,
    email?: string,
    mobileNo?: string
  ) {
    this.pageInvestor = this.afs.collection('InvestorData', ref => {
      let query:
        | firebase.firestore.CollectionReference
        | firebase.firestore.Query = ref;
      if (email && email.length > 0) {
        query = query.where('email', '==', email);
      } else if (mobileNo && mobileNo.length > 0) {
        query = query.where('phone', '==', mobileNo);
      } else if (newStatus) {
        query = query.where('status', '==', status.new);
      }
      if (eid) {
        query = query.where('creatorId', '==', eid);
      }
      return query
        .orderBy('updatedAt', 'desc')
        .startAfter(firstElement.updatedAt)
        .limit(page);
    });
    return this.pageInvestor;
  }

  addUserData(user, uid) {
    // Sets user data to firestore on login
    // this.currentUser = user;
    console.log(user);
    console.log('useradmin' + user.admin);
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${uid}`);

    const data: User = {
      uid: uid,
      email: user.email,
      displayName: user.displayName,
      roles: {
        superAdmin: user.superAdmin,
        admin: user.admin,
        editor: user.editor,
        subscriber: true
      }
    };

    return userRef.set(data, { merge: true });
  }
  // filter(newStatus?: boolean, email?: string, mobileNo?: string) {
  //   this.pageInvestor = this.afs.collection('InvestorData', ref => {
  //     if (email && email.length > 0) {
  //       return ref
  //         .where('email', '==', email)
  //         .orderBy('updatedAt')
  //         .limit(page);
  //     }
  //     if (mobileNo && mobileNo.length > 0) {
  //       return ref
  //       .where('phone', '==', mobileNo)
  //       .orderBy('updatedAt')
  //       .limit(page);
  //     }
  //     if (newStatus) {
  //       return ref
  //       .where('status', '==', status.new)
  //       .orderBy('updatedAt')
  //       .limit(page);
  //     }
  //   });
  //   this.afs.
  // }
}



// WEBPACK FOOTER //
// ./src/app/modules/manage-user/manage-user.service.ts